import type { PropsWithChildren } from 'react'
import { motion } from 'motion/react'

export function Page({ children, className = '' }: PropsWithChildren<{ className?: string }>) {
  return (
    <motion.main
      id="main-content"
      className={`page ${className}`.trim()}
      initial={{ opacity: 0, clipPath: 'inset(0 0 8% 0)' }}
      animate={{ opacity: 1, clipPath: 'inset(0 0 0% 0)' }}
      exit={{ opacity: 0, clipPath: 'inset(0 0 0 0)' }}
      transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.main>
  )
}
